define.alias("shared/utils/feature-requirements", "settings/utils/feature-requirements");